interface IConfiguration {
	sliderAutoplay: boolean;
}

const configurationEl = document.getElementById('configuration-var');
export const configuration: IConfiguration = JSON.parse(configurationEl.textContent || configurationEl.innerHTML);

document.addEventListener('DOMContentLoaded', () => {
	const cookieBanner = document.querySelector<HTMLElement>('.eu-cookies');
	if (cookieBanner === null)
	{
		return;
	}

	const buttons = cookieBanner.querySelectorAll<HTMLButtonElement>('button');
	buttons.forEach((button) => {
		button.addEventListener('click', () => {
			const date = new Date();
			date.setFullYear(date.getFullYear() + 10);
			document.cookie = 'eu-cookies=1; path=/; expires=' + date.toUTCString();
			cookieBanner.style.display = 'none';
		});
	});
});
